<template>
    <div role="tabcard" class="tab-pane" id="work-order-calendar">
        <div class="modal fade" id="modal-update-work-order" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">

                    <div class="modal-header">
                        <h4 >Update dependent work orders?</h4>
                    </div>

                    <div class="modal-body" v-if="showingDependencyWarning">
                        <p>
                            <span class="font-weight-600">{{ this.pendingDroppedEvent.title }}</span> has the following dependent work orders:
                        </p>
                        <p>
                            <ul>
                                <li v-for="workOrder in pendingDependentWorkOrders">{{ workOrder.title }}</li>
                            </ul>
                        </p>
                        <p>
                            Would you like to automatically reschedule all dependent work orders?
                        </p>
                    </div>

                    <div class="modal-footer">
                        <div class="btn btn-info" @click="updateAllDependencies">
                            Reschedule all dependent work orders
                        </div>

                        <div class="btn btn-info" @click="updateSingleWorkOrder">
                            Reschedule just this one work order
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="calendar-view-parent">
            <calendar-view
                :show-date="showDate"
                :enableDragDrop="true"
                :events="events"
                v-on:drop-on-date="workOrderDroppedOnDate(...arguments)"
                class="theme-default holiday-us-traditional holiday-us-official">
                <calendar-view-header
                    slot="header"
                    slot-scope="t"
                    :header-props="t.headerProps"
                    @input="setShowDate" />
            </calendar-view>
        </div>
    </div>
</template>

<script>
    // https://github.com/richardtallent/vue-simple-calendar
    import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"

    export default {
        props: ['project'],

        watch: {
            project: function() {
                this.getWorkOrders();
            }
        },

        created: function() {
            this.registerEvents();
            this.getWorkOrders();
        },

        components: {
            CalendarView,
            CalendarViewHeader,
        },

        mounted: function() {
            var vm = this;
            $('#modal-update-work-order').on('hidden.bs.modal', function () {
                vm.clearPendingState();
            })
        },

        data: function() {
            return {
                showingDependencyWarning: false,
                showDate: new Date(),
                workOrders: [],
                events: [],
                pendingDroppedEvent: null,
                pendingDependentWorkOrders: null,
                pendingNewDate: null
            };
        },

        computed: {
            
        },

        methods: {
            registerEvents: function() {
                var vm = this;
                Bus.$on('new-work-order-created', function (response) {
                    //vm.newWorkOrderCreated(response);
                    vm.getWorkOrders();
                    return true;
                });
                Bus.$on('work-order-updated', function (response) {
                    //vm.workOrderUpdated(response);
                    vm.getWorkOrders();
                    return true;
                });
                Bus.$on('work-orders-updated', function () {
                    vm.getWorkOrders();
                    return true;
                });
                Bus.$on('work-order-deleted', function(response) {
                    //vm.workOrderDeleted(response.id);
                    vm.getWorkOrders();
                    return true;
                });
            },

            clearPendingState() {
                this.hideDependencyWarning();
                this.pendingDependentWorkOrders = null;
                this.pendingDroppedEvent = null;
                this.pendingNewDate = null;
            },

            showDependencyWarning() {
                this.showingDependencyWarning = true;
                $('#modal-update-work-order').modal('show');
            },

            hideDependencyWarning() {
                $('#modal-update-work-order').modal('hide');
                this.showingDependencyWarning = false;
            },

            updateAllDependencies() {

                this.hideDependencyWarning();

                let droppedEvent = this.pendingDroppedEvent;
                let date = this.pendingNewDate;

                for (var index in this.events) {
                    var event = this.events[index];
                    if (event.id == droppedEvent.id) {

                        let allEventsToUpdateOnServer = [];

                        let updatedEvent = droppedEvent.originalEvent;

                        let eventDuration = moment(updatedEvent.endDate).diff(updatedEvent.startDate);
                        let durationBetweenNewStartAndOldStart = moment(date).diff(updatedEvent.startDate);

                        let newStartDate = moment(date).format("YYYY-MM-DD HH:mm:ss");
                        let newEndDate = moment(date).add(eventDuration).format("YYYY-MM-DD HH:mm:ss");

                        updatedEvent.startDate = newStartDate;
                        updatedEvent.endDate = newEndDate;

                        // Set the first event to it's new location in the UI
                        Vue.set(this.events, this.events.indexOf(event), updatedEvent);
                        allEventsToUpdateOnServer.push(updatedEvent);

                        // Now get the work order, to check for it's dependent work orders
                        //let workOrder = this.$_.findWhere(this.workOrders, { id: droppedEvent.id });

                        // For each dependent work order, find it's
                        // corresponding event, and update it.
                        _.forEach(this.pendingDependentWorkOrders, dependentWorkOrder => {

                            // Dependent work orders might not have a start/end date.
                            if (!moment(dependentWorkOrder.startDate).isValid()){
                                return;
                            }

                            let dependentEvent = this.$_.findWhere(this.events, { id: dependentWorkOrder.id });

                            // Push the dependent start & ends up (or back) by 
                            // as much as the parent event was moved.
                            dependentEvent.startDate = moment(dependentEvent.startDate).add(durationBetweenNewStartAndOldStart).format("YYYY-MM-DD HH:mm:ss");
                            dependentEvent.endDate = moment(dependentEvent.endDate).add(durationBetweenNewStartAndOldStart).format("YYYY-MM-DD HH:mm:ss");

                            let eventIndex = this.$_.findIndex(this.events, event => { event.id == dependentEvent.id });
                            Vue.set(this.events, eventIndex, dependentEvent);
                            allEventsToUpdateOnServer.push(dependentEvent);
                        });

                        this.updateDependentWorkOrders(updatedEvent.id, allEventsToUpdateOnServer);
                        break;
                    }
                }
            },

            updateSingleWorkOrder() {
                this.hideDependencyWarning();

                let droppedEvent = this.pendingDroppedEvent;
                let date = this.pendingNewDate;

                for (var index in this.events) {
                    var event = this.events[index];
                    if (event.id == droppedEvent.id) {
                        let updatedEvent = droppedEvent.originalEvent;

                        let eventDuration = moment(updatedEvent.endDate).diff(updatedEvent.startDate);
                        let durationBetweenNewStartAndOldStart = moment(date).diff(updatedEvent.startDate);

                        let newStartDate = moment(date).format("YYYY-MM-DD HH:mm:ss");
                        let newEndDate = moment(date).add(eventDuration).format("YYYY-MM-DD HH:mm:ss");

                        updatedEvent.startDate = newStartDate;
                        updatedEvent.endDate = newEndDate;

                        this.updateWorkOrder(updatedEvent);

                        Vue.set(this.events, this.events.indexOf(event), updatedEvent);
                        break;
                    }
                }
            },

            setShowDate(d) {
                this.showDate = d;
            },

            workOrderDroppedOnDate: function(droppedEvent, date) {
                // First get the associated work order
                // If it has dependencies, ask the user what to do
                // If it doesn't, just update it.
                let workOrder = _.find(this.workOrders, workOrder => {
                    if (workOrder.id == droppedEvent.id) {
                        return workOrder;
                    }
                });

                this.pendingDroppedEvent = droppedEvent;
                this.pendingNewDate = date;

                if (workOrder.all_dependent_work_orders.length > 0) {
                    this.pendingDependentWorkOrders = this.getDependentWorkOrders(workOrder);
                    console.log(this.pendingDependentWorkOrders);
                    this.showDependencyWarning();
                } 
                else {
                    this.updateSingleWorkOrder();
                }

            },

            getDependentWorkOrders: function(workOrder) {
                let dependentWorkOrders = [];

                _.forEach(workOrder.all_dependent_work_orders, dependentWorkOrder => {
                    dependentWorkOrders.push(dependentWorkOrder);
                    if (dependentWorkOrder.all_dependent_work_orders && dependentWorkOrder.all_dependent_work_orders.length > 0) {
                        dependentWorkOrders.push(...this.getDependentWorkOrders(dependentWorkOrder));
                    }
                });
                
                return dependentWorkOrders;
            },

            getWorkOrders: function()
            {
                if (!this.project) {
                    return;
                }

                this.clearPendingState();

                axios.get(`/api/workorders/${this.project.id}`)
                    .then(response =>
                    {
                        this.loadingWorkOrders = false;
                        this.workOrders = response.data;
                        this.createEventsFromWorkOrders();
                    })
                    .catch(error =>
                    {
                        this.loadingWorkOrders = false;
                    });
            },

            updateDependentWorkOrders: function(primaryWorkOrderId, updatedEvents) {

                let updatedWorkOrders = [];

                _.forEach(updatedEvents, updatedEvent => {
                    let updatedWorkOrder = {
                        id: updatedEvent.id,
                        startDate: updatedEvent.startDate,
                        endDate: updatedEvent.endDate,
                    }
                    updatedWorkOrders.push(updatedWorkOrder);
                });

                axios.put(`/api/workorders/${primaryWorkOrderId}/dependencies`, updatedWorkOrders)
                    .then(reponse => {
                        Bus.$emit('work-orders-updated');
                    })
                    .catch(error => {
                        // Sync the calendar to server on error
                        console.log(error);
                        this.getWorkOrders();
                    });
            },

            updateWorkOrder: function(updatedEvent) {
                let updatedWorkOrder = {
                    id: updatedEvent.id,
                    startDate: updatedEvent.startDate,
                    endDate: updatedEvent.endDate,
                }

                axios.put(`/api/workorders/${updatedWorkOrder.id}`, updatedWorkOrder)
                    .then(response => {
                        Bus.$emit('work-order-updated', response.data);
                    })
                    .catch(error => {
                        // Sync the calendar to server on error
                        console.log(error);
                        this.getWorkOrders();
                    });
            },

            getClassForStatus: function(workOrder) {
                if (workOrder.status == "Not started"){
                    return 'status-not-started';
                }
                else if (workOrder.status == "In progress"){
                    return 'status-in-progress';
                }
                else if (workOrder.status == "Complete"){
                    return 'status-complete';
                }

                return 'status-not-started';
            },

            createEventsFromWorkOrders: function() {
                let newEvents = [];

                _.forEach(this.workOrders, workOrder => {
                    let color = this.getClassForStatus(workOrder);
                    let tempEvent = {
                        id: workOrder.id,
                        startDate: workOrder.start_date,
                        endDate: workOrder.end_date,
                        title: workOrder.title,
                        classes: color
                    };
                    newEvents.push(tempEvent);
                });

                this.events = newEvents;
            }
        }
    }
</script>
